var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toggle-line"},[_c('div',{staticClass:"on-of-button",class:{ active: _vm.active },on:{"click":function($event){return _vm.changeStatus()}}},[_c('div',{staticClass:"circle"},[_c('Icon',{attrs:{"iconName":"check","width":"16","height":"16","viewBox":"0 0 16 16"}})],1)]),_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }